import React from 'react';

import { BodyCopy } from '@xingternal/typography';

import { useHeaderContext } from '../../../context';

export const CompanyName: React.FC = () => {
  const { companyName } = useHeaderContext();
  return (
    <BodyCopy size="medium" sizeWide="xlarge" noMargin>
      {companyName}
    </BodyCopy>
  );
};
